import React from 'react'
import { PoliticasWrapper } from 'styles/global'
import Simple from 'layouts/simple'

const TermoDeUso = () => {
  return (
    <>
      <Simple>
        <PoliticasWrapper>
          <div className="container">
            <h1 className="titulo">Termos de Política e Uso</h1>

            <div className="d-flex flex-column gap-4">
              <section>
                <p>Agradecemos sua visita!</p>
                <p>
                  Somos um correspondente bancário que utiliza desta plataforma
                  digital com a intenção de facilitar o seu acesso a nossos
                  produtos. Possuímos a autorização do Banco Central do Brasil
                  (Resolução CMN nº 3954, de 24 de novembro de 2011) para a
                  comercialização do consignado, visando o interesse de
                  aposentados e pensionistas do INSS e servidores públicos.
                </p>
                <p>
                  A&nbsp;
                  <strong>
                    RIBERCRED SERVIÇOS DE INFORMAÇÕES CADASTRAIS LTDA.
                  </strong>
                  , pessoa jurídica de direito privado inscrita no CNPJ sob o
                  nº.&nbsp;
                  <strong>04.380.132/0001-47</strong>, tem sua matriz instalada
                  na Av. Antônio Diederichsen, nº 400, sala 16, Jardim América,
                  na cidade de Ribeirão Preto/SP., CEP: 14.020-250.
                </p>
                <p>
                  O usuário da plataforma está ciente e informado que ao
                  utilizar o nosso site concorda com os termos de uso e
                  políticas de privacidades nele contido, tendo por sua
                  responsabilidade qualquer dano ou ato praticado dentro da
                  plataforma.
                </p>
                <p>
                  A Ribercred atribui-se ao direito de suspender ou interromper
                  a visita de qualquer usuário que seja suspeito de praticar
                  fraudes ou qualquer outra atitude suspeita que venha favorecer
                  a seu favor ou benefício próprio.
                </p>
                <p>
                  Caso o usuário não concorde com os termos e condições
                  apresentadas em nossa plataforma, não deverá utilizá-la.
                </p>
                <p>
                  A Ribercred se coloca à disposição para qualquer dúvida ou
                  feedback sobre a nossa plataforma de serviço.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">POLÍTICA DE PRIVACIDADE</h2>
                <p>
                  Ao utilizar o Site da Ribercred, automaticamente, você
                  concorda com todos os termos da nossa Política de Privacidade
                  e com os nossos Termos e Condições de Uso. Portanto, deve ser
                  lido e compreendido antes de utilizá-lo.
                </p>
                <p>
                  Caso você, usuário, não concorde com nossa Política de
                  Privacidade e/ou com nossos Termos de Condições de Uso,
                  recomendamos que não utilize o site da Ribercred.
                </p>

                <h3 className="subtitulo">Informações coletadas:</h3>
                <ul>
                  <li>
                    <strong>Pessoais:</strong> Nome, endereço, telefone, CPF,
                    RG, data nascimento, sexo, informações financeiras
                    relevantes (renda, despesas, bens e outros dados) para
                    oferecermos produtos adequados às suas necessidades.
                  </li>
                  <li>
                    <strong>Não Pessoais:</strong> IP (Internet Protocol), sua
                    localização, tipo de computador, tipo de celular, tipo de
                    navegador, páginas e serviços acessados, entre outros.
                  </li>
                </ul>

                <h3 className="subtitulo">
                  Como as Informações são coletadas:
                </h3>
                <ul>
                  <li>
                    Através de seu cadastro no site da Ribercred ou solicitações
                    de cotações e propostas de instituições financeiras,
                    companhias de seguros ou bandeira de cartão de crédito de
                    instituições parceiras.
                  </li>
                  <li>
                    <strong>Cookies:</strong> através de identificação da
                    interação com o site da Ribercred. Os Cookies são utilizados
                    para proporcionar uma melhor experiência em nosso site, onde
                    podemos sugerir recursos personalizados como artigos,
                    produtos, infográfico, publicidade, entre outros.
                  </li>
                </ul>
                <p>
                  Caso haja o interesse em interromper as informações não
                  pessoais, você deverá desabilitar o salvamento de Cookies do
                  seu navegador de internet ou encerrar a utilização do site da
                  Ribercred.
                </p>

                <h3 className="subtitulo">
                  Como as Informações coletadas serão utilizadas:
                </h3>
                <ul>
                  <li>Traçar perfil demográfico de uso do site.</li>
                  <li>
                    Entra em contato com o usuário para sanar dúvidas em relação
                    às informações coletadas ou devidas verificações.
                  </li>
                  <li>
                    Completar solicitações de cotação, propostas de produtos ou
                    serviços oferecidos pelas Instituições Parceiras.
                  </li>
                  <li>
                    Cruzar informações através do Google Analytics, analisando o
                    perfil do cliente para oferecer produtos e serviços que mais
                    se adequem à sua realidade.
                  </li>
                  <li>
                    Desenvolver e oferecer produtos e serviços de terceiros.
                  </li>
                  <li>
                    Garantir e proteger a segurança e integridade de nossa base
                    de dados.
                  </li>
                </ul>

                <h3 className="subtitulo">
                  Armazenamento e Proteção de Informações Coletadas:
                </h3>
                <p>
                  Todos os dados e informações que constam nessa Política de
                  Privacidade serão armazenados em nosso banco de dados sob
                  todas as práticas de segurança de informação, preservando a
                  confidencialidade das suas informações. Entretanto, caso haja
                  alguma quebra de segurança por força maior, causando o acesso
                  indevido ou divulgação de informações do usuário, a Ribercred
                  não será responsabilizada nem fará qualquer compensação ao
                  usuário.
                </p>
                <p>
                  Esta política de Privacidade pode ser modificada a qualquer
                  momento, sem aviso prévio por parte da Ribercred. A última
                  versão estará disponível no site da Ribercred e as alterações
                  serão aplicadas assim que disponibilizadas no site da
                  Ribercred.
                </p>

                <h3 className="subtitulo">Compartilhamento de Informações:</h3>
                <p>
                  Para que a Ribercred possa viabilizar alguns serviços
                  prestados, o compartilhamento das informações se faz
                  necessários, porém, seguindo todos os trâmites necessários
                  para a devida privacidade do usuário.
                </p>

                <h4 className="subtitulo">
                  Quando haverá compartilhamento de Informações?
                </h4>
                <ul>
                  <li>
                    <strong>Instituições Parceiras:</strong> para receber
                    propostas de produtos e serviços financeiros como cartão de
                    crédito, seguro, empréstimo, financiamento ou outros, as
                    Instituições Parceiras necessitam de seus dados pessoais e
                    não pessoais. As informações somente serão disponibilizadas
                    quando o usuário solicitar ou manifestar interesse em algum
                    produto ou serviço oferecido pela Instituição Parceira.
                    Lembrando que cada Instituição Parceira possui sua própria
                    Política de Privacidade, portanto, o usuário não deve
                    solicitar um produto/serviço caso não esteja de acordo com a
                    Política utilizada por Instituição Parceira.
                  </li>
                  <li>
                    <strong>Novos Negócios:</strong> Caso haja fusão, parceria
                    ou aquisição de novas empresas, as informações de usuários
                    são transferidas, porém, mantendo a Política de Privacidade.
                  </li>
                  <li>
                    <strong>Ordem Judicial:</strong> Em caso de Ordem Judicial,
                    a Ribercred poderá compartilhar dados pessoais do usuário.
                  </li>
                  <li>
                    <strong>Com autorização Expressa do Usuário:</strong> Caso
                    haja a necessidade de compartilhar informações, a Ribercred
                    enviará uma notificação ao usuário, solicitando sua
                    aprovação ou reprovação.
                  </li>
                </ul>

                <p>
                  Ao solicitar uma simulação de crédito no site Ribercred, o
                  usuário concorda e autoriza o Banco ou a Instituição Parceira
                  ter acesso e consultar seus dados de depósitos, aplicações em
                  outras instituições financeiras e informações a seu respeito
                  constantes junto aos órgãos de proteção ao crédito – Serasa e
                  SPC.
                </p>
                <p>
                  As informações armazenadas no site Ribercred poderão ser
                  fornecidas a terceiros, conforme mencionado acima, visando a
                  geração de uma Proposta de Crédito, em conformidade com a
                  Política de Avaliação de Crédito. As informações poderão ser
                  utilizadas para administração e manutenção dos Serviços de
                  Cobrança, gestão de aplicações, manutenção de banco de dados e
                  sugestão de investimentos.
                </p>
              </section>

              <section>
                <h2 className="subtitulo">TERMOS DE USO</h2>

                <div className="space-y-4">
                  <div>
                    <h3 className="topicos">Acesso:</h3>
                    <p>
                      A Ribercred oferece aos seus usuários um ambiente de livre
                      acesso. Com responsabilidade de cada frequentador, sem a
                      prescrição de nenhum tipo de cadastro.
                    </p>
                  </div>

                  <div>
                    <h3 className="topicos">Simulação:</h3>
                    <p>
                      O usuário possui total liberdade para realizar simulações
                      de créditos podendo contratar serviços ao estar de acordo
                      com as tarifas o os custos impostos de cada negociação.
                      Sempre presente e informado em cada plataforma de
                      negociação.
                    </p>
                  </div>

                  <div>
                    <h3 className="topicos">Cadastro:</h3>
                    <p>
                      Mediante a contratação de nossos produtos, o usuário irá
                      realizar um login de cadastro contendo sua senha desejada.
                      Documentos pessoais deverão ser enviados conforme
                      solicitado o passo a passo do processo de aprovação e
                      venda.
                    </p>
                  </div>

                  <div>
                    <h3 className="topicos">Análise de crédito:</h3>
                    <p>
                      Toda análise de crédito é realizada pelos bancos parceiros
                      da Ribercred. Sendo de total responsabilidade dos mesmos
                      aprovações, limites disponíveis e possíveis recusas.
                    </p>
                  </div>

                  <div>
                    <h3 className="topicos">Idade mínima:</h3>
                    <p>
                      Idade mínima para utilização de nossos produtos e
                      conteúdos: 18 anos.
                    </p>
                  </div>

                  <p>
                    Com base na Lei N°9.279, de 14 de maio de 1996, todos os
                    direitos de Propriedade Intelectual estão reservados a
                    Ribercred como idealizadora desta plataforma.
                  </p>

                  <p>
                    Esta plataforma fica protegida de forma autoral pela
                    Ribercred, sendo assim, qualquer violação de seus direitos
                    poderá acarretar processos judiciais.
                  </p>

                  <p>
                    Ao efetuar acesso a nossa plataforma, o usuário concorda em
                    receber mensagens e notificações de alertas, cadastros ou
                    fechamento de contratos.
                  </p>

                  <p>
                    Os dados do usuário permanecerão a disposição da empresa e
                    quando solicitados deverão ser apagados de nossos sistemas.
                  </p>

                  <p>
                    Informamos que a plataforma Ribercred é totalmente digital e
                    que nenhum contato será feito antes do usuário se
                    prontificar a eventuais negociações. Qualquer ato suspeito
                    deverá ser comunicado imediatamente as autoridades
                    responsáveis.
                  </p>

                  <p>
                    A Ribercred considera de total importância o sigilo e
                    manuseio de dados de usuários. Por isto fará tudo que tiver
                    em seu alcance para proteger os dados de seus visitantes.
                  </p>

                  <p>
                    Fica extremamente proibido qualquer tipo de download de
                    dados ou outros documentos que favorecem terceiros, para
                    aplicação de futuras negociações de concorrentes.
                  </p>

                  <p>
                    O usuário se torna altamente responsável pelos processos e
                    navegação na plataforma, de acordo com os Termos de Uso e
                    Política de Privacidade aqui contida.
                  </p>

                  <p>
                    É de responsabilidade do usuário adquirir meios de proteção
                    e antivírus para seu aparelho de navegação no site. O acesso
                    de um usuário cadastrado se baseia em login e senha antes
                    fornecidas pela plataforma e cadastrada e acordo com cada
                    solicitante.
                  </p>
                </div>
              </section>

              <section className="pt-4">
                <p className="text-sm text-muted-foreground italic">
                  Este termo foi atualizado em&nbsp;
                  <span className="data-atualizacao">12/03/2025.</span>
                </p>
              </section>
            </div>
          </div>
        </PoliticasWrapper>
      </Simple>
    </>
  )
}

export default TermoDeUso
